import React from "react";
import ContactsTab from "./ContactsTab";
import { formatLongDate } from "../../lib/format";

const DEFAULT_CATEGORIES = [
  { key: "Attorney", color: "#0F1115" },
  { key: "CPA", color: "#0090FF" },
  { key: "Insurance", color: "#46A758" },
  { key: "Wealth", color: "#FFC53D" },
  { key: "Fractional", color: "#F76B15" },
  { key: "Residential Realtor", color: "#E54D2E" },
  { key: "Commercial Realtor", color: "#8E4EC6" },
  { key: "Residential Broker", color: "#E93D82" },
  { key: "Commercial Broker", color: "#BB9457" },
  { key: "Title", color: "#1B9AAA" },
  { key: "Residential Lending Partner", color: "#0E7AB2" },
  { key: "Commercial Lending Partner", color: "#0067B8" },
  { key: "Other", color: "#707070" },
];

const FIELDS = [
  { name: "first_name", label: "First Name" },
  { name: "last_name", label: "Last Name" },
  { name: "email", label: "Email" },
  { name: "phone", label: "Phone" },
  { name: "company", label: "Company" },
  { name: "category", label: "Category", type: "select", options: [] },
  { name: "notes", label: "Notes", type: "textarea", full: true },
];

const COLUMNS = [
  {
    key: "first_name",
    label: "Name",
    render: (_, r) => (
      <span className="font-semibold">{r.first_name} {r.last_name}</span>
    ),
  },
  { key: "email", label: "Email", render: (v) => <span className="font-mono-rw text-xs">{v || "—"}</span> },
  { key: "phone", label: "Phone", render: (v) => <span className="font-mono-rw text-xs">{v || "—"}</span> },
  { key: "company", label: "Company" },
  {
    key: "category",
    label: "Category",
    render: (v, _r, ctx) =>
      v ? (
        <span
          className="text-[10px] uppercase tracking-widest text-white px-2 py-0.5 rounded"
          style={{ background: ctx?.catColor?.[v] || "#0F1115" }}
        >
          {v}
        </span>
      ) : "—",
  },
  { key: "notes", label: "Notes", render: (v) => <span className="text-xs text-neutral-500 line-clamp-1">{v || "—"}</span> },
  { key: "last_contact_date", label: "Last Contact", render: (v) => <span className="font-mono-rw text-xs">{v ? formatLongDate(v) : "—"}</span> },
];

const CSV_COLS = [
  { key: "first_name", label: "First Name" },
  { key: "last_name", label: "Last Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "company", label: "Company" },
  { key: "category", label: "Category" },
  { key: "notes", label: "Notes" },
  { key: "last_contact_date", label: "Last Contact" },
];

export default function COIContacts() {
  return (
    <ContactsTab
      type="coi"
      title="Centers of Influence"
      eyebrow="Contacts"
      dot="#E54D2E"
      description="Attorneys, CPAs, lenders, realtors and other partners that drive referrals."
      columns={COLUMNS}
      fields={FIELDS}
      excelColumns={["first name", "last name", "email", "phone", "company", "category", "notes"]}
      csvColumns={CSV_COLS}
      defaultCategories={DEFAULT_CATEGORIES}
      categoryKind="contacts_coi"
      groupByCompany={true}
    />
  );
}
